// extracted by mini-css-extract-plugin
export default {"intro":"Home_intro__jke-w"};